import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=d2066230&scoped=true&"
import script from "./accountForm.vue?vue&type=script&lang=js&"
export * from "./accountForm.vue?vue&type=script&lang=js&"
import style0 from "./accountForm.vue?vue&type=style&index=0&id=d2066230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2066230",
  null
  
)

export default component.exports